
const currentStoreData = window.currentStore;
const externalStoresData = window.countryBlocks;

/**************************** Helper ****************************/
function populateStoreElem(template, storeObj, showTitle = true, showImage = true, lazyImg = true) {

    const regionalImg = template.querySelector('[data-store-image]');
    const regionalText = template.querySelector('[data-store-title]');
    template.setAttribute('href', storeObj.url);
    template.setAttribute('title', storeObj.name);

    if (storeObj['highlight'] === null && storeObj.highlight === true)
    {
        template.classList.add('highlight');
    }
    // debugger
    if (showImage)
    {
        regionalImg.setAttribute('src', storeObj.icon);
        regionalImg.setAttribute('alt', storeObj.name);
        if (lazyImg)
        {
            regionalImg.setAttribute('loading', 'lazy');
        }
    }
    else
    {
        regionalImg.remove();
    }

    if (showTitle)
    {
        regionalText.innerText = storeObj.name;
    }
    else
    {
        regionalText.remove();
    }

    return template

}


/**************************** Dropdown ****************************/

const geoDropdowns = document.querySelectorAll('.js-geo-dropdown')
if (geoDropdowns && externalStoresData)
{
    // Open selector 
    const openGeoDropdown = (elem) => { elem.classList.add('open') };
    // Close selector 
    const closeGeoDropdown = (elem) => { elem.classList.remove('open'); }

    geoDropdowns.forEach((geoDropdown) => {
        
        const dropdownSettings = JSON.parse(geoDropdown.dataset.settings);
        const redirectStoreObj = geoDropdown.querySelector('.js-geo-dropdown__store.js-geo-dropdown__store.js-template');
        const fragment = document.createDocumentFragment();
        const currentStoreHeader = geoDropdown.querySelector('.js-geo-dropdown__current-store-header');
        const currentStore = geoDropdown.querySelector('.js-geo-dropdown__current-store');
        const redirectStores = geoDropdown.querySelector('.js-geo-dropdown__redirect-stores');

        const openGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--open');
        const closeGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--close');
        const toggleGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--toggle');

        openGeoDropdownElems.forEach(openGeoDropdownElem => {
            openGeoDropdownElem.addEventListener('click', () => {
                openGeoDropdown(geoDropdown);
            })
        })

        closeGeoDropdownElems.forEach(closeGeoDropdownElem => {
            closeGeoDropdownElem.addEventListener('click', () => {
                closeGeoDropdown(geoDropdown);
            })
        })

        /*Close whan clicking outside */
        document.addEventListener('click', function(event) {
            var isClickInside = geoDropdown.contains(event.target);

            if (!isClickInside)
            {
                closeGeoDropdown(geoDropdown);
            }
        });

        toggleGeoDropdownElems.forEach(toggleGeoDropdownElem => {
            toggleGeoDropdownElem.addEventListener('click', () => {
                if (geoDropdown.classList.contains('open'))
                {
                    closeGeoDropdown(geoDropdown);
                } else
                {
                    openGeoDropdown(geoDropdown);
                }
            })
        });

        if (dropdownSettings.imagePosition === 'right')
        {
            geoDropdown.classList.add('image-position--right')
        }
        if (dropdownSettings.roundedImages)
        {
            geoDropdown.classList.add('images--rounded')
        }

        // Add content to Dropdown - Current store header
        populateStoreElem(currentStoreHeader, currentStoreData, dropdownSettings.showLanguageTitleInHeader, dropdownSettings.showImages, lazyImg = false)
        // Add content to Dropdown - Current store
        populateStoreElem(currentStore, currentStoreData, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages)

        // Add content to Dropdown - External stores
        if (externalStoresData)
        {
            externalStoresData.forEach(externalStore => {
                const template = redirectStoreObj.cloneNode(true);
                template.classList.remove('js-template');
                fragment.appendChild(populateStoreElem(template, externalStore, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages));
            });
        }

        redirectStoreObj.remove();
        redirectStores.appendChild(fragment);

    })//End foreach



}
else
{
    // Hide dropdowns if empty
    geoDropdowns.forEach((geoDropdown) => {
        geoDropdown.style.display = 'none'
    });
}

